import axios from "axios";
export const BASE_URL = `${process.env.REACT_APP_API_BASE}/LOGINREGISTRATION/api/v1`;
export const ENROLLMENT_URL = `${process.env.REACT_APP_API_BASE}/ENROLLMENTSERVICE/enrollments`;
export const INSTRUCTOR_URL = `${process.env.REACT_APP_API_BASE}/INSTRUCTORSERVICES/api/v1`;
export const COURSES_URL = `${process.env.REACT_APP_API_BASE}/COURSEMANAGEMENTSERVICE/api/v1`;
export const PAYMENTS_URL = `${process.env.REACT_APP_API_BASE}/COURSEMANAGEMENTSERVICE/api/v1/payments`;
export const CERTIFICATE_URL = `${process.env.REACT_APP_API_BASE}/COURSEMANAGEMENTSERVICE/api`;
export const INTERVIEWMANAGEMENT_URL = `${process.env.REACT_APP_API_BASE}/INTERVIEWMANAGEMENTSERVICE/api`;
export const PROGRAMMINGSERVICE_URL= `${process.env.REACT_APP_API_BASE}/PROGRAMMINGSERVICE/api`;
export const AI_INTERVIEW_URL = `${process.env.REACT_APP_API_BASE}/AIINTERVIEW/api`;
export const JOBS_PORTAL_URL =`${process.env.REACT_APP_API_BASE}/JOBPORTALMICROSERVICE`;
export const ANALYTICS_URL = `${process.env.REACT_APP_API_BASE}/LOGINREGISTRATION/api/v1/user-analytics`;


// REACT_APP_API_BASE=http://localhost:8085/api/v1
// REACT_APP_API_COURSES=http://localhost:8082/api
// REACT_APP_API_ENROLLMENTS=http://localhost:8089/enrollments
// REACT_APP_API_INSTRUCTORS=http://localhost:8087/api/v1 
// REACT_APP_API_FRONTEND= http://localhost:3000


export const logUserActivity = async (username, activityType) => {
  return axios.post(`${ANALYTICS_URL}/log`, null, {
    params: { username, activityType }
  });
};

 
const SaveSearchedCourses = async(courseId, userId) =>{
  try{
    const response = await axios.post(`${COURSES_URL}/searchHistory?courseId=${courseId}`,null,{ params: {userId}});
    return response ;
  } catch (error){
    throw (error)
  }
}

export { SaveSearchedCourses };

const getAverageRatingByCourse = async(courseId) => {
  try{
    const response = await axios.get(`${COURSES_URL}/course/${courseId}/average-rating`);
    return response;
  } catch (error){
    throw error;
  }
}

export { getAverageRatingByCourse };

const runJavaProgram = async (data) => {

  try {
    const response = await axios.post(`${COURSES_URL}/run-code`, data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error executing Code program:", error.response?.data || error.message);
    throw error.response?.data || "Failed to execute code";
  }
};

export { runJavaProgram };

const getInstructorEarningsByCourse = async(courseId) =>{

  try{
    const response = await axios.get(`${INSTRUCTOR_URL}/course/${courseId}/earnings`)
     return response;
  } catch (error){
    throw(error)
  }
}

export { getInstructorEarningsByCourse }

const coursesByInstructor = async(userId) =>{
  try{
    const response = await axios.get(`${COURSES_URL}/course/instructor/${userId}`)
     return response;
  } catch(error){
    throw(error)
  }
}

export { coursesByInstructor }

const createCourse = async(data) =>{
   try{
    const response = await axios.post(`${COURSES_URL}/course`,data, {
      // headers: {  
        // Authorization: `Bearer ${localStorage.getItem('token')}`
    // }
    }
  );
     return response;
  } catch(error){
    throw error;
  }
};

export { createCourse };

const getCurrentUserId = () => {
  return localStorage.getItem('userId');
};

const createCourseEnrollment = async (courseId) => {
  const userId = getCurrentUserId();

  if (!userId) {
    throw new Error('User ID is not available');
  }

  const enrollmentDTO = {
    courseId,
    userId
  };

  try {
    const response = await axios.post(
      `${ENROLLMENT_URL}/createEnrollment`,
      enrollmentDTO
    );
    return response;
  } catch (error) {
    console.error('Error creating enrollment:', error);
    throw error;
  }
};

export { createCourseEnrollment };



const getCourseById = async (courseId) => {
  try{
    const response = await axios.get(`${COURSES_URL}/course/${courseId.courseId}`);
    return response;
  } catch(error){
    throw error
  }
};

export { getCourseById };



const register = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/register`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export { register };


const loginWithUserName = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/loginWithUserName`, data, {
      withCredentials: true, 
    });
    return response;
  } catch (error) {
    throw error;
  }
};


export { loginWithUserName };

const profile = async (email) => {

  try{
    const response = await axios.get(`${BASE_URL}/profile`,email, {
      headers: {  
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }});
    return response;
  } catch(error){
    throw error;
  }
};


export { profile };
const profileUpdate = async (formData) => {
  try {
    console.log('Form data:', formData);

    const response = await fetch(`${BASE_URL}/profileUpdate`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',  
      },
      body: JSON.stringify(formData),
    });

    console.log('Response Status:', response.status);

    if (!response.ok) {
      const errorData = await response.json();
       throw new Error(errorData.message || 'Failed to update profile');
    }

    const data = await response.json();
     return data;
  } catch (error) {
    console.error('Error updating profile:', error.message);
    throw error;
  }
};

export { profileUpdate };


const forgetPassword = async (email) => {
  try {
    const response = await axios.post(`${BASE_URL}/forgot-password`, null, { params: { email } })
    return response;
  } catch (error) {
    throw error;
  }
}

export { forgetPassword };

const resetPassword = async (token,newPassword) => {
  try{
    const response = await axios.post(`${BASE_URL}/reset-password`,null,{params:{token,newPassword}});
    return response;
  }catch(error){
    throw error;
  }
}

export {resetPassword};

const listCourses = async (data) =>{
  try{
    const response = await axios.get(`${COURSES_URL}/course`,data)
    return response;
  } catch(error){
    throw(error);
  }
}

export {listCourses};


const PaginatedCourses = async(term,page,itemsPerPage) =>{

  try{
    const response = await axios.get(`${COURSES_URL}/pagination`,null,{params:{term,page,itemsPerPage}})
    return response;
  } catch(error){
    throw (error)
  }
}

export {PaginatedCourses};


const mostSearchedCourses = async () => {

  try{
    const response = await axios.get(`${COURSES_URL}/course/mostSearchedCourses`)
     return response;
  } catch(error){
    throw error
  }
}

export { mostSearchedCourses } ;

const  PrevSearchedCourses= async (userId) => {

  try {
    const response = await axios.get(`${COURSES_URL}/searchHistory/previousSearchedHistoryCourses`, { params: {userId}} );
    return response.data;
  } catch (error) {
     throw error;
  }
};

export { PrevSearchedCourses };


const LangRelevantCourses = async (lang) => {

  try {
    const response = await axios.get(`${COURSES_URL}/course/filter?language=${lang}`);
    return response.data;
  } catch (error) {
     throw error;
  }
};

export { LangRelevantCourses };



const addToCart = async (userId, courseId) => {
  try {
    const response = await axios.post(`${COURSES_URL}/cart/${userId}/add/${courseId}/`);
    return response;
  } catch (error) {
     throw error;
  }
};

const removeFromCart = async (userId, courseId) => {
  try {
    const response = await axios.delete(`${COURSES_URL}/cart/${userId}/remove/${courseId}/`);
    return response;
  } catch (error) {
     throw error;
  }
};

const getCartItems = async (userId) => {
  try {
    const response = await axios.get(`${COURSES_URL}/cart/${userId}`);
    return response.data;
  } catch (error) {
     throw error;
  }
};

const clearCart = async (userId) => {
  try {
    const response = await axios.delete(`${COURSES_URL}/cart/${userId}/clear`);
    return response.data;
  } catch (error) {
     throw error;
  }
};

export { addToCart, removeFromCart, getCartItems ,clearCart};